import Navlinks from "./Navlinks";
import styles from './styles/navlinks.module.css';
import {footerLinks} from "./dict/links";

const FooterNavlinks = () => (
    <Navlinks links={footerLinks} containerClass={styles['menu-container-footer']} linkClass={`${styles['link']} ${styles['link-footer']}`} type={'footer'}/>
)

export default FooterNavlinks;
